import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';
import classNames from 'classnames';

const Button = props => (
    <div
        className={classNames('ui-dropdownButton ui-btn', { 'ui-btn_primary': props.opened })}
        onClick={() => props.onButtonClick()}
    >
        {props.children}
        <Svg
            size="Medium"
            iconName="down"
            className={classNames(
                'ui-dropdownButton__icon',
                { 'ui-dropdownButton__icon_selected': props.opened }
            )}
        />
    </div>
);

Button.propTypes = {
    children: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired
};

export default Button;



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/components/Button.js